@if (!teamsControl?.value.length && !usersControl?.value.length && !requirementsControl?.value.length) {
  <button class="add-requirement-button" (click)="onAddRequirement()">
    <img src="assets/img/icons/plus-brown-filled.svg" />
    Assign People
  </button>
} @else {
  <button class="small-add-requirement-button" (click)="onAddRequirement()">
    <img src="assets/img/icons/plus-brown-filled.svg" />
  </button>
}
@for (team of teamsControl?.value; track team) {
  <div class="chip" [class.light-bg]="!newTask">
    <div class="avatar">{{ teamsMap[team]?.name | userAvatar | uppercase }}</div>
    <span>{{ teamsMap[team]?.name }}</span>
    <button class="remove-requirement-button" (click)="onRemoveTeam(team)">
      <img src="assets/img/icons/x-gray-filled.svg" />
    </button>
  </div>
}
@for (user of usersControl?.value; track user) {
  <div class="chip" [class.light-bg]="!newTask">
    <oph-avatar [user]="usersMap[user]" [size]="23"></oph-avatar>
    <span>{{ usersMap[user]?.username }}</span>
    <button class="remove-requirement-button" (click)="onRemoveUser(user)">
      <img src="assets/img/icons/x-gray-filled.svg" />
    </button>
  </div>
}
@for (requirement of requirementsControl?.value; track requirement) {
  <div class="chip" [class.light-bg]="!newTask">
    <img class="star-icon" src="assets/img/icons/star-dark-brown.svg" />
    <span>{{ skillsMap[requirement]?.name }}</span>
    <button class="remove-requirement-button" (click)="onRemoveRequirement(requirement)">
      <img src="assets/img/icons/x-gray-filled.svg" />
    </button>
  </div>
}
